var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"not-found"},[_c('div',{staticClass:"content"},[_c('h1',[_vm._v("404")]),_c('div',{staticClass:"content-desc"},[_vm._v("抱歉，你访问的页面不存在")]),_c('el-button',{attrs:{"type":"primary"}},[_vm._v("返回首页")])],1)])}
var staticRenderFns = []

export { render, staticRenderFns }